// The SW itself is generated by vite-plugin-pwa (Workbox), which also registers it (registerSW.js).

const UPDATE_CHECK_INTERVAL_MS = 60_000;

/**
 * Asks the browser to look for a new SW every minute; by itself it looks only on navigation. An
 * offline tick is skipped, the next tick checks again.
 */
export function startServiceWorkerUpdateChecks() {
    setInterval(() => {
        if (!navigator.onLine) {
            return;
        }
        navigator.serviceWorker
            ?.getRegistration()
            .then(async (registration) => registration?.update())
            .catch((error: unknown) => {
                console.log('SW: update check failed', error);
            });
    }, UPDATE_CHECK_INTERVAL_MS);
}

export async function loadNewServiceWorker() {
    try {
        await activateNewServiceWorker();
    } catch (error) {
        console.error('SW: new SW did not activate', error);
    } finally {
        globalThis.location.reload();
    }
}

/**
 * Resolves once the installing/waiting SW is active: a reload before that is served by the old SW
 * from its precache, i.e. the old build again.
 */
async function activateNewServiceWorker(): Promise<void> {
    const registration = await navigator.serviceWorker?.ready;
    const worker = registration?.waiting ?? registration?.installing;
    if (worker == null) {
        console.log('SW: no new SW to activate');

        return;
    }

    await new Promise<void>((resolve, reject) => {
        const check = () => {
            console.log('SW: new SW', worker.state);
            if (worker.state === 'activated') {
                resolve();
            } else if (worker.state === 'redundant') {
                reject(new Error('SW: new SW became redundant'));
            }
        };
        worker.addEventListener('statechange', check);
        check();
        // The generated SW skips waiting on its own; this covers one that waits for the message.
        worker.postMessage({ type: 'SKIP_WAITING' });
    });
}
